import React from "react";
import DocScanner from "./DocScanner";

/**
 * MobileCapture — Backwards-compatible proxy for DocScanner.
 * All existing call-sites across GradeMe automatically get the
 * high-performance DocScanner engine without any prop or API breakage.
 */
const MobileCapture = (props) => {
  return <DocScanner {...props} />;
};

export default MobileCapture;
